// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteBrandsStyles } from "@steiner/Overrides/Widgets/Header/AutocompleteBrands";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

autocompleteBrandsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

autocompleteBrandsStyles.brandsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

autocompleteBrandsStyles.brandItemText = {
    size: "12px",
    lineHeight: "15px",
};

autocompleteBrandsStyles.link = {
    typographyProps: {
        size: "12px",
        lineHeight: "15px",
    },
};

autocompleteBrandsStyles.headerText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};
